import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, Home } from "lucide-react";
import { Button } from "@/components/ui/button";

const NAV_LINKS = [
  { href: "#how-it-works", label: "How It Works", testid: "nav-how-it-works" },
  { href: "#benefits", label: "Why Us", testid: "nav-benefits" },
  { href: "#areas", label: "Service Areas", testid: "nav-areas" },
  { href: "#faq", label: "FAQ", testid: "nav-faq" },
];

export default function Header({ onCtaClick }) {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 backdrop-blur-xl bg-[#F9F8F6]/85 border-b border-[#E2DDD7]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-4 flex items-center justify-between gap-2">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2 min-w-0">
          <div className="w-9 h-9 rounded-xl bg-[#D95D39] flex items-center justify-center text-white shrink-0">
            <Home strokeWidth={1.75} className="w-5 h-5" />
          </div>
          <div className="leading-tight min-w-0">
            <div className="font-[Outfit] font-semibold text-[#2C3D30] text-base truncate">T&amp;R Capital</div>
            <div className="text-[10px] uppercase tracking-[0.18em] text-[#5B6B5F] truncate">LLC · Cash Buyers</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testid}
              className="text-sm text-[#2C3D30] hover:text-[#D95D39] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Button
            data-testid="header-cta-button"
            onClick={onCtaClick}
            className="hidden sm:inline-flex tr-btn-primary rounded-full px-6 h-11 font-medium"
          >
            Get My Cash Offer
          </Button>
          <button
            data-testid="mobile-menu-toggle"
            className="lg:hidden p-2 text-[#2C3D30]"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
          >
            {open ? <X /> : <Menu />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden border-t border-[#E2DDD7] bg-white">
          <div className="px-6 py-4 flex flex-col gap-4">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`mobile-${l.testid}`}
                onClick={() => setOpen(false)}
                className="text-base text-[#2C3D30]"
              >
                {l.label}
              </a>
            ))}
            <Button
              data-testid="mobile-cta-button"
              onClick={() => {
                setOpen(false);
                onCtaClick?.();
              }}
              className="tr-btn-primary rounded-full h-12 font-medium"
            >
              Get My Cash Offer
            </Button>
          </div>
        </div>
      )}
    </header>
  );
}
